import * as errorMessages from "../constants/ErrorMessages";
import { compareAsc, isValidDate, mergeDateAndTime, parseDate } from "./date";

export const required = (id, value) => {
  return value ? null : id + " er påkrevd";
};

export const mustBeAPositiveInteger = (value) =>
  Number.isInteger(Number(value)) && Number(value) > 0
    ? null
    : errorMessages.mustBeAPositiveInteger;

export const fraDateTimeTilDateTimeValidation = (state, handleChange) => {
  const { fraDato, fraTid, tilDato, tilTid } = state;
  const dFraDato = parseDate(fraDato);
  const dFraTid = parseDate(fraTid);
  const dTilDato = parseDate(tilDato);
  const dTilTid = parseDate(tilTid);
  let fraDatoValidationErrorText = null;
  let fraTidValidationErrorText = null;
  let tilDatoValidationErrorText = null;
  let tilTidValidationErrorText = null;

  if (fraDato && !isValidDate(dFraDato)) {
    fraDatoValidationErrorText = errorMessages.dateFromIsNotValid(fraDato);
  }
  if (fraTid && !isValidDate(dFraTid)) {
    fraTidValidationErrorText = errorMessages.TimeFromIsNotValid;
  }
  if (tilDato && !isValidDate(dTilDato)) {
    tilDatoValidationErrorText = errorMessages.DateToIsNotValid;
  }
  if (tilTid && !isValidDate(dTilTid)) {
    tilTidValidationErrorText = errorMessages.TimeToIsNotValid;
  }

  if (isValidDate(dTilDato) && !dFraDato) {
    fraDatoValidationErrorText = errorMessages.DateFromIsRequired;
  }
  if (isValidDate(dFraDato) && !dTilDato) {
    tilDatoValidationErrorText = errorMessages.DateToIsRequired;
  }

  if (fraTid && !dFraDato) {
    fraDatoValidationErrorText = errorMessages.DateFromIsRequired;
  }
  if (tilTid && !dTilDato) {
    tilDatoValidationErrorText = errorMessages.DateToIsRequired;
  }

  if (
    isValidDate(dFraDato) &&
    isValidDate(dTilDato) &&
    compareAsc(dFraDato, dTilDato) === 1
  ) {
    fraDatoValidationErrorText = errorMessages.FraDatoAndTilDato;
  }

  if (
    isValidDate(dFraDato) &&
    isValidDate(dFraTid) &&
    isValidDate(dTilDato) &&
    isValidDate(dTilTid)
  ) {
    const from = mergeDateAndTime(dFraDato, dFraTid);
    const to = mergeDateAndTime(dTilDato, dTilTid);
    if (from && to && compareAsc(from, to) === 1) {
      fraDatoValidationErrorText = errorMessages.FraDatoAndTilDato;
    }
  }

  handleChange("fraDatoValidationErrorText", fraDatoValidationErrorText);
  handleChange("fraTidValidationErrorText", fraTidValidationErrorText);
  handleChange("tilDatoValidationErrorText", tilDatoValidationErrorText);
  handleChange("tilTidValidationErrorText", tilTidValidationErrorText);

  return fraDatoValidationErrorText ||
    fraTidValidationErrorText ||
    tilDatoValidationErrorText ||
    tilTidValidationErrorText
    ? false
    : true;
};

export const getDateTimeValidationError = (dateTimes) => {
  const { fraDato, fraTid, tilDato, tilTid } = dateTimes;
  const dFraDato = parseDate(fraDato);
  const dFraTid = parseDate(fraTid);
  const dTilDato = parseDate(tilDato);
  const dTilTid = parseDate(tilTid);
  let fraDatoValidationErrorText = null;
  let fraTidValidationErrorText = null;
  let tilDatoValidationErrorText = null;
  let tilTidValidationErrorText = null;

  if (fraDato && !isValidDate(dFraDato)) {
    fraDatoValidationErrorText = errorMessages.dateFromIsNotValid;
  }
  if (fraTid && !isValidDate(dFraTid)) {
    fraTidValidationErrorText = errorMessages.TimeFromIsNotValid;
  }
  if (tilDato && !isValidDate(dTilDato)) {
    tilDatoValidationErrorText = errorMessages.DateToIsNotValid;
  }
  if (tilTid && !isValidDate(dTilTid)) {
    tilTidValidationErrorText = errorMessages.TimeToIsNotValid;
  }

  if (isValidDate(dTilDato) && !dFraDato) {
    fraDatoValidationErrorText = errorMessages.DateFromIsRequired;
  }
  if (isValidDate(dFraDato) && !dTilDato) {
    tilDatoValidationErrorText = errorMessages.DateToIsRequired;
  }

  if (fraTid && !dFraDato) {
    fraDatoValidationErrorText = errorMessages.DateFromIsRequired;
  }
  if (tilTid && !dTilDato) {
    tilDatoValidationErrorText = errorMessages.DateToIsRequired;
  }

  if (
    isValidDate(dFraDato) &&
    isValidDate(dTilDato) &&
    compareAsc(dFraDato, dTilDato) === 1
  ) {
    fraDatoValidationErrorText = errorMessages.FraDatoAndTilDato;
  }

  if (
    isValidDate(dFraDato) &&
    isValidDate(dFraTid) &&
    isValidDate(dTilDato) &&
    isValidDate(dTilTid)
  ) {
    const from = mergeDateAndTime(dFraDato, dFraTid);
    const to = mergeDateAndTime(dTilDato, dTilTid);
    if (from && to && compareAsc(from, to) === 1) {
      fraDatoValidationErrorText = errorMessages.FraDatoAndTilDato;
    }
  }

  return {
    fraDatoValidationErrorText,
    fraTidValidationErrorText,
    tilDatoValidationErrorText,
    tilTidValidationErrorText,
  };
};

export const fromDateToDateRequiredValidation = (
  fraDato,
  tilDato,
  handleChange,
) => {
  if (!fraDato && !tilDato) {
    handleChange(
      "fraDatoValidationErrorText",
      errorMessages.DateFromIsRequired,
    );
    return false;
  }
  return true;
};
